import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LandingPage from '../components/LandingPage';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      const currentLanguage = i18n.language === 'en' ? 'en' : 'es';
      const mentionsRoute = t('routes.mentions');
      navigate(`/${currentLanguage}${mentionsRoute}`);
    }
  }, [authLoading, isAuthenticated, navigate, t, i18n.language]);

  // Show loading while checking authentication
  if (authLoading) {
    return null;
  }

  return <LandingPage />;
};

export default Home;